import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import classNames from "classnames";
import { Delta } from "../../types";
import styles from "./style.module.scss";

interface DeltaBadgeProps {
  delta?: Delta;
  /**
   * Drops the arrow glyph while keeping the tinted pill - the treatment the
   * design uses for band rows, book ranks and the funnel rings.
   */
  bare?: boolean;
  /**
   * Drops the trailing "vs X" caption. The funnel shows bare percentages,
   * so the caption would add a line the design does not have.
   */
  hideAgainst?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

/**
 * The tinted up/down pill that follows every figure in the analytics screens.
 * Direction comes from `delta.tone`, never from parsing the string.
 */
function DeltaBadge({
  delta,
  bare,
  hideAgainst,
  size = "md",
  className,
}: DeltaBadgeProps) {
  if (!delta) return null;

  const isDown = delta.tone === "danger";

  return (
    <span className={classNames(styles.wrap, className)}>
      <span
        className={classNames(
          styles.badge,
          styles[delta.tone],
          styles[size],
          bare && styles.noIcon
        )}
      >
        {!bare &&
          (isDown ? (
            <ArrowDownwardIcon className={styles.icon} />
          ) : (
            <ArrowUpwardIcon className={styles.icon} />
          ))}
        {delta.value}
      </span>
      {delta.against && !hideAgainst && (
        <span className={styles.against}>vs {delta.against}</span>
      )}
    </span>
  );
}

export default DeltaBadge;
